export default __webpack_public_path__ + "img/77d134bce5d5acb5ef42a824427cdbf1.png";